// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    if (!burgerButton) return;
    const update = () => {
        const open = document.body.classList.contains('gh-head-open');
        burgerButton.setAttribute('aria-expanded', String(open));
        burgerButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    burgerButton.addEventListener('click', function () {
        document.body.classList.toggle('gh-head-open');
        update();
    });
    document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && document.body.classList.contains('gh-head-open') && !document.querySelector('.lds-appearance[open]')) {
            document.body.classList.remove('gh-head-open');
            update();
            burgerButton.focus();
        }
    });
}
